import { render, staticRenderFns } from "./ErrorLayout.vue?vue&type=template&id=2c83e7ea&scoped=true"
import script from "./ErrorLayout.vue?vue&type=script&lang=js"
export * from "./ErrorLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c83e7ea",
  null
  
)

export default component.exports